export type completedStepsState = {
    completedStepsArray: number[]
};

export const initialCompletedStepsState = {
    completedStepsArray: []
};